import { render, staticRenderFns } from "./SalesRevenueSummaryList.vue?vue&type=template&id=87cc2730&scoped=true"
import script from "./SalesRevenueSummaryList.vue?vue&type=script&lang=js"
export * from "./SalesRevenueSummaryList.vue?vue&type=script&lang=js"
import style0 from "./SalesRevenueSummaryList.vue?vue&type=style&index=0&id=87cc2730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc2730",
  null
  
)

export default component.exports